import { cn } from "@/lib/class-control";

interface SectionDividerProps {
  title: string;
  className?: string;
}

export function SectionDivider({ title, className }: SectionDividerProps) {
  return (
    <div className={cn("flex items-center gap-2 w-full", className)}>
      <p className="font-['Plus_Jakarta_Sans'] font-semibold text-[11px] text-[#b0b0b0] uppercase leading-normal whitespace-nowrap">
        {title}
      </p>
      <div className="flex-1 h-[0.5px] bg-[#5d5d5d]" />
    </div>
  );
}
